// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex_flex__UTqdl"};